import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroIndustrialExcellence() {
  return <section data-section-id="222132" id="tu-futuro-comienza-aquí" className="relative w-full h-[80vh] min-h-[600px] flex items-center justify-center bg-background text-foreground">
      {}

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center justify-center text-center gap-6">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/hero_header.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/hero_header.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/hero_header.png-wvc-sizes" alt="Estudiantes en formación" className="w-full max-w-2xl rounded-lg shadow-md" loading="lazy" decoding="async" />
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-foreground font-default max-w-5xl tracking-tighter leading-tight">Más de 25 años formando personas nos avalan, <br />nuestros estudiantes lo confirman</h1>
        
        <p className="text-lg text-muted-foreground max-w-[60ch] font-default !font-semibold md:text-xl">Descubre una experiencia educativa diseñada para superar las asignaturas que te resultan más difíciles. En CENTRO DE ESTUDIOS COSMOS, transformamos el aprendizaje en una herramienta de cambio real para tu formación.</p>
        
        <div className="mt-4 flex flex-row gap-4">
          <Button asChild size="lg" className="text-base h-12 px-8 bg-primary text-primary-foreground hover:shadow-lg transition-all duration-300 rounded-md">
            
          </Button>
          <Button asChild variant="ghost" size="lg" className="text-base h-12 px-8 border border-border hover:bg-accent hover:text-accent-foreground transition-all duration-300 rounded-md">
            
          </Button>
        </div>
      </div>
    </section>;
}